import { SelectInput, required, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { roleIsClient, roleIsService } from '@/constants/Roles.js';
import { getRoleChoices } from '@/components/users/roleChoices.js';

export const RoleInput = () => {
    const { setValue } = useFormContext();
    const translate = useTranslate();
    const handleChangeRole = event => {
        const role = event.target.value;
        if (!roleIsClient(role)) {
            setValue('contractorIds', null);
            setValue('contractorCollectionPointIds', null);
            setValue('contractors', null);
        }
        if (!roleIsService(role)) {
            setValue('serviceCompanyId', null);
        }
    };

    return (
        <SelectInput
            name='role'
            source='role'
            label={translate('resources.user.labels.roleSelect')}
            choices={getRoleChoices(translate)}
            validate={[required(translate('common.validation.required'))]}
            fullWidth
            onChange={handleChangeRole}
            sx={{
                '& .MuiFormHelperText-root': {
                    display: 'none',
                },
            }}
        />
    );
};
